module.exports = __webpack_public_path__ + "d3290b56e206aa094513e9b713e81bce.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Step Cut Trapezoid@2x.png
// module id = 330
// module chunks = 0